import React, { useContext } from 'react'
import ClearFilterButton from './ClearFilterButton'
import ResetAllFiltersButton from './ResetAllFiltersButton'

import { SEARCH, SearchContext } from "../SearchContext"

const FiltersLists = () => {

  const { state: {
    filters,
    defaultFilterValues
  }, dispatch } = useContext(SearchContext)
  const _setFilters = (payload) => dispatch({ type: SEARCH.FILTERS.SET, payload })
  const _initiateFilterSearch = (payload) => dispatch({ type: SEARCH.FILTERS.SEARCH, payload })

  const _resetFilter = (type) => {
    let tmp = {...filters}
    tmp[type] = defaultFilterValues[type]
    _setFilters(tmp)
    _initiateFilterSearch({value: true})
  }


  const _resetAllFilters = () => {
    let tmp = {...filters}
    tmp = defaultFilterValues
    _setFilters(tmp)
    _initiateFilterSearch({value: true})
  }

  const _priceRangeChanged = () => {
    return (filters.priceRange.min !== defaultFilterValues.priceRange.max) ||
           (filters.priceRange.min !== defaultFilterValues.priceRange.max)
  }

  return (
    <aside className={`filter-results-list`}>
      {
        filters.hotelName.length > 0 && (
        <section className="hotel-name">
          <h4 className="space-between">
            <span>Hotel: {filters.hotelName}</span>
            <ClearFilterButton onClick={() =>_resetFilter("hotelName")} />
          </h4>
        </section>
      )}
      {
        filters.starRating !== defaultFilterValues.starRating && (
        <section className="star-rating">
          <h4 className="space-between">
            <span>{filters.starRating} stars</span>
            <ClearFilterButton onClick={() =>_resetFilter("starRating")} />
          </h4>
        </section>
      )}

      {
        _priceRangeChanged() && (
        <section className="price-range">
          <h4 className="space-between">
            <span>${filters.priceRange.min} to ${filters.priceRange.max}</span>
            <ClearFilterButton onClick={() =>_resetFilter("priceRange")} />
          </h4>
        </section>
      )}

      <div className="actions">
        <ResetAllFiltersButton onClick = { _resetAllFilters } />
      </div>
    </aside>
  )
}

export default FiltersLists
